
















import { defineComponent, type PropType } from "vue-demi";
import getValueForProp from "../../../../helper/getValueForProp";
import type {
  DataSourceResponse,
  PageDataPropUnion,
} from "@constructor/shared-entity/type";

export default defineComponent({
  name: "MPGroup",
  props: {
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
    data: {
      type: Object as PropType<DataSourceResponse>,
      default: () => ({}),
    },
  },
  computed: {
    title() {
      const type = getValueForProp("titleSourceType", this.prop);
      if (type === "from-data-source" && this.data?.title) {
        return this.data.title;
      } else {
        return getValueForProp("sectionTitle", this.prop);
      }
    },
    link() {
      const type = getValueForProp("linkSourceType", this.prop);
      if (type === "from-data-source" && this.data?.link) {
        return this.data.link;
      } else {
        return getValueForProp("sectionLink", this.prop);
      }
    },
    linkText() {
      return getValueForProp("linkSectionText", this.prop);
    },
  },
});
